import {
  detailsOfNaturalPersonHolding,
  identification
} from '@ligo/bv-flow/store';
import { i18n } from 'apps/bv-flow/src/boot/i18n';
const address = [['company_name'], ['email'], ['incorporation_speed']];

export const otherQuestions = [
  ['lives_in_netherlands'],
  ['english_proficient'],
  ['pep']
];

const company_sections = [address];
const shareholder_sections = [
  detailsOfNaturalPersonHolding,
  identification,
  otherQuestions
];

export const useSteps = () => {
  const steps = [
    {
      name: 'generic-sections',
      props: {
        locale: 'company_name',
        sections: company_sections,
        resource: 'main'
      }
    },
    {
      name: 'generic-sections',
      props: {
        locale: 'shareholder_information',
        sections: shareholder_sections,
        resource: 'p1',
        booleanDialog: {
          title: i18n.t(
            'incorporate_holding.shareholder_information.no_pep',
          ),
          confirmLabel: i18n.t('incorporate_holding.shareholder_information.other_services'),
          fieldName: 'pep',
          triggerValue: true,
          index: 2
        }
      }
    },
    { name: 'pie-chart' },
    { name: 'contract-upsell' },
    { name: 'dga' },
    { name: 'extra-services' },
    { name: 'preview-documents' }
  ];
  return { steps };
};
